/* Maytrix saved-design recovery. No cart writes and no subscription changes. */
(function () {
  'use strict';
  if (window.MaytrixDesignRecovery) return;
  var PREFIX = 'maytrix:recovery:v1:';
  var pending = read('sessionStorage', 'pending');
  var activeConfig = '';
  var saveState = '';
  var inflight = null;
  var retryTimer;
  var attempt = 0;
  var emailInFlight = null;
  var recordEndpoint = document.currentScript && document.currentScript.getAttribute('data-record-endpoint') || '';
  var recordJobs = {};
  var saveGeneration = 0;
  var pendingBag = read('sessionStorage', 'pending-bag');
  var bagRunning = false;
  var bagAttempt = 0;
  var bagTimer;

  // Export the current 3D sign directly; saved designs do not load room scenes.
  async function captureDesignWhenReady() {
    var until = Date.now() + 8000;
    var stableSince = 0;
    function fingerprint() {
      var viewer = window.__MAYTRIX_VIEWER__;
      return JSON.stringify(viewer && typeof viewer.getState === 'function' ? viewer.getState() : {});
    }
    var originalDesign = fingerprint();
    while (Date.now() < until) {
      if (fingerprint() !== originalDesign) return null;
      var motion = window.MaytrixModelMotion;
      var renderer = window.__MAYTRIX_ROOM_RENDERER__;
      var canvas = document.querySelector('#viewer-3d-root .r3f-canvas.show-canvas');
      var ready = canvas && renderer && typeof renderer.capture === 'function' && (!motion ||
        (motion.openingProgress.value >= 0.999 && motion.center.progress.value >= 0.999 &&
         motion.sides.progress.value >= 0.999 && (!motion.colorUntil || performance.now() >= motion.colorUntil)));
      if (ready) {
        if (!stableSince) stableSince = Date.now();
        if (Date.now() - stableSince > 350) {
          var artwork = renderer.capture({ maxEdge: 900, mode: 'room-on', view: 'front', aspect: 1 });
          if (!artwork || !artwork.width || !artwork.height) return null;
          var hero = document.createElement('canvas');
          hero.width = 900; hero.height = 900;
          var context = hero.getContext('2d');
          if (!context) return null;
          context.fillStyle = '#101014'; context.fillRect(0, 0, 900, 900);
          var scale = Math.min(900 / artwork.width, 900 / artwork.height);
          context.drawImage(artwork, (900 - artwork.width * scale) / 2, (900 - artwork.height * scale) / 2,
            artwork.width * scale, artwork.height * scale);
          return { room: 'design', label: 'Your design', dataUrl: hero.toDataURL('image/jpeg', 0.85) };
        }
      } else stableSince = 0;
      await new Promise(function (resolve) { setTimeout(resolve, 100); });
    }
    return null;
  }

  async function recordDesign(payload, snapshot) {
    if (!recordEndpoint) return payload;
    var rooms = [];
    try {
      snapshot = await bounded(snapshot || captureDesignWhenReady());
      if (snapshot && snapshot.room === 'design' && /^data:image\/jpeg;base64,/.test(snapshot.dataUrl || '')) rooms = [snapshot];
    } catch (_) { /* The saved link still works if its design image cannot render. */ }
    try {
      var response = await fetch(recordEndpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, payload, { rooms: rooms })),
        signal: AbortSignal.timeout(15000), credentials: 'omit'
      });
      if (!response.ok) return payload;
      var record = await response.json();
      if (!record.saved || record.ConfigID !== payload.ConfigID) return payload;
      var images = (record.rooms || []).filter(function (room) {
        try { return new URL(room.url).origin === new URL(recordEndpoint).origin; } catch (_) { return false; }
      });
      var designImage = images.find(function (room) { return room.room === 'design'; });

      return Object.assign({}, payload, {
        DesignImageURL: designImage ? designImage.url : '',
        RoomPreviewURL: '',
        RoomPreviewImages: [],
        RoomPreviewDesignURL: ''
      });
    } catch (_) { return payload; }
  }

  function read(storage, key) {
    try { return JSON.parse(window[storage].getItem(PREFIX + key)); } catch (_) { return null; }
  }
  function write(storage, key, value) {
    try { window[storage].setItem(PREFIX + key, JSON.stringify(value)); } catch (_) {}
  }
  function bounded(promise) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('Recovery timed out')); }, 10000);
      Promise.resolve(promise).then(function (value) {
        clearTimeout(timer); resolve(value);
      }, function (error) { clearTimeout(timer); reject(error); });
    });
  }
  function identity() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!match) return '';
      var value = JSON.parse(atob(decodeURIComponent(match[1])));
      return value.$exchange_id || value.$id || value.$kid || '';
    } catch (_) { return ''; }
  }
  function emailKnown() {
    var marker = read('localStorage', 'email-provided');
    return !!(marker && marker.identity && marker.identity === identity() &&
      Date.now() - marker.at < 30 * 86400000);
  }
  function valid(payload) {
    if (!payload || !/^[A-Za-z0-9_-]{16,128}$/.test(payload.ConfigID || '')) return false;
    try {
      var url = new URL(payload.DesignURL);
      return url.protocol === 'https:' && url.hostname === 'maytrix.com' &&
        url.pathname === '/products/custom-infinity-mirror' &&
        url.searchParams.get('configid') === payload.ConfigID && url.searchParams.get('review') === '1';
    } catch (_) { return false; }
  }
  function render() {
    var notice = document.querySelector('[data-myx-recovery-notice]');
    if (!notice) return;
    // An identified SMS profile alone is not evidence that an email was supplied.
    var accepted = activeConfig && read('sessionStorage', 'accepted:' + activeConfig);
    var visible = saveState === 'saved' && emailKnown() && accepted && accepted === identity();
    notice.hidden = !visible;
    notice.textContent = visible ? 'Your design is saved.' : '';
  }
  function schedule() {
    clearTimeout(retryTimer);
    if (attempt++ < 6) retryTimer = setTimeout(flush, Math.min(1000 * Math.pow(2, attempt), 15000));
  }
  async function flushBag() {
    if (bagRunning || !pendingBag || !/^[A-Za-z0-9_-]{16,128}$/.test(pendingBag.configId || '') || Date.now() - pendingBag.at > 86400000) return;
    bagRunning = true;
    var job = pendingBag;
    var retry = true;
    try {
      var sdk = window.klaviyo;
      if (!sdk || typeof sdk.isIdentified !== 'function' || typeof sdk.track !== 'function') return;
      if (emailInFlight) await emailInFlight;
      if (!await bounded(sdk.isIdentified()) || !identity()) return;
      var key = 'bag:' + job.configId;
      if (read('sessionStorage', key) === identity()) { retry = false; return; }
      var payload = recordJobs[job.configId] ? await recordJobs[job.configId] : read('sessionStorage', 'design:' + job.configId);
      if (!valid(payload) && recordEndpoint) {
        var response = await fetch(recordEndpoint.replace(/\/$/, '') + '/' + encodeURIComponent(job.configId), { credentials: 'omit', signal: AbortSignal.timeout(8000) });
        if (response.ok) payload = await response.json();
      }
      if (!valid(payload)) {
        var link = new URL('https://maytrix.com/products/custom-infinity-mirror');
        link.searchParams.set('configid', job.configId); link.searchParams.set('review', '1');
        payload = { ConfigID: job.configId, DesignURL: link.href };
      }
      var accepted = await bounded(sdk.track('Maytrix Design Added to Bag', Object.assign({}, payload, {
        '$event_id': 'maytrix-verified-bag-' + job.configId, RecoveryVersion: '1', Source: 'Verified Add to Bag'
      })));
      if (accepted === true) { write('sessionStorage', key, identity()); retry = false; }
    } catch (_) {} finally {
      bagRunning = false;
      if (!retry && pendingBag === job) { pendingBag = null; write('sessionStorage', 'pending-bag', null); }
      clearTimeout(bagTimer);
      if (pendingBag && bagAttempt++ < 6) bagTimer = setTimeout(flushBag, Math.min(1000 * Math.pow(2, bagAttempt), 15000));
    }
  }
  async function flush() {
    if (inflight || !valid(pending)) return;
    var sdk = window.klaviyo;
    if (!sdk || typeof sdk.isIdentified !== 'function' || typeof sdk.track !== 'function') {
      schedule(); return;
    }
    var payload = pending;
    inflight = payload.ConfigID;
    try {
      if (emailInFlight) await emailInFlight;
      if (!await bounded(sdk.isIdentified())) { schedule(); return; }
      var person = identity();
      if (!person) { schedule(); return; }
      if (read('sessionStorage', 'accepted:' + payload.ConfigID) === person) { render(); return; }
      // A stable event ID prevents duplicate flow entries when the client retries.
      var accepted = await bounded(sdk.track('Finished Custom Design', Object.assign({}, payload, {
        '$event_id': 'maytrix-finish-' + payload.ConfigID,
        RecoveryVersion: '1'
      })));
      if (accepted !== true) { schedule(); return; }
      write('sessionStorage', 'accepted:' + payload.ConfigID, person);
      render();
    } catch (_) { schedule(); }
    finally { inflight = null; }
    if (pending && pending.ConfigID !== payload.ConfigID) flush();
  }
  window.MaytrixDesignRecovery = {
    prepare: function () {
      if (!recordEndpoint) return null;
      try { return captureDesignWhenReady().catch(function () { return null; }); }
      catch (_) { return null; }
    },
    saved: function (payload, snapshot) {
      if (!valid(payload)) return;
      payload = Object.assign({}, payload, { RoomPreviewURL: '', RoomPreviewImages: [], RoomPreviewDesignURL: '' });
      // Record all finished designs; email recovery remains restricted to known subscribers by the flow.
      var configId = payload.ConfigID;
      var generation = ++saveGeneration;
      pending = payload;
      write('sessionStorage', 'pending', payload);
      if (!recordJobs[configId]) recordJobs[configId] = recordDesign(payload, snapshot);
      recordJobs[configId].then(function (enriched) {
        write('sessionStorage', 'design:' + configId, enriched);
        if (generation !== saveGeneration) return enriched;
        pending = enriched;
        write('sessionStorage', 'pending', enriched);
        attempt = 0;
        flush();
        return enriched;
      });
    },
    recordReview: function (payload, snapshot) {
      if (!valid(payload) || recordJobs[payload.ConfigID]) return;
      // Returning review visits create the internal record without restarting recovery emails.
      recordJobs[payload.ConfigID] = (async function () {
        return recordDesign(payload, snapshot);
      })();
      recordJobs[payload.ConfigID].then(function (enriched) {
        write('sessionStorage', 'design:' + payload.ConfigID, enriched);
      });
    },
    review: function (config, state) {
      activeConfig = config || '';
      saveState = state;
      render();
    }
  };
  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;
    var email = String((detail.metaData || {}).email || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    // The popup owns consent. Identify only the address the visitor just submitted.
    emailInFlight = (async function () {
      for (var i = 0; i < 15; i++) {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') break;
        await new Promise(function (resolve) { setTimeout(resolve, 1000); });
      }
      if (!window.klaviyo || typeof window.klaviyo.identify !== 'function') return;
      await bounded(window.klaviyo.identify({ email: email }));
      var person = identity();
      if (person && await bounded(window.klaviyo.isIdentified())) {
        write('localStorage', 'email-provided', { identity: person, at: Date.now() });
      }
    }()).catch(function () {}).finally(function () {
      emailInFlight = null;
      attempt = 0;
      render();
      flush();
      flushBag();
    });
  });
  window.addEventListener('online', function () { attempt = 0; bagAttempt = 0; flush(); flushBag(); });
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) { attempt = 0; bagAttempt = 0; flush(); flushBag(); }
  });
  // This analytics event is dispatched only after cart contents have been verified.
  document.addEventListener('maytrix:commerce-analytics', function (event) {
    if (!event.detail || event.detail.name !== 'design_added_to_bag') return;
    var configId = event.detail.properties && event.detail.properties.config_id;
    if (!/^[A-Za-z0-9_-]{16,128}$/.test(configId || '')) return;
    pendingBag = { configId: configId, at: Date.now() };
    write('sessionStorage', 'pending-bag', pendingBag);
    bagAttempt = 0;
    flushBag();
  });
  flush();
  flushBag();
}());
